<template>
  <div class="statistics">
    <div class="row">
      <div class="key">装箱数量:</div>
      <div class="val">{{ statistics.order_box_detail_num }}</div>
    </div>

    <div class="row">
      <div class="key">合计金额:</div>
      <div class="val">{{ statistics.total_amount.toFixed(2) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
  },
  computed: {
    statistics() {
      let total = {
        order_box_detail_num: 0,
        total_amount: 0,
      }
      this.selectList.forEach(item => {

        total.order_box_detail_num += item.order_detail_this_box_num - 0
        total.total_amount += item.order_detail_this_box_num * item.confirm_price
        // total.total_amount += item.total_amount_detail.total_amount - 0
        // total.order_detail_count += item.order_detail_count - 0
      })
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}
</style>